import api from 'api';

export const exportAssistedInstalls = api(
  'POST /api/reports/assistedinstalls/export',
  {
    responseType: 'blob',
  }
);
